import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=263bd3cc&scoped=true"
import script from "./normal.vue?vue&type=script&lang=js"
export * from "./normal.vue?vue&type=script&lang=js"
import style0 from "./normal.vue?vue&type=style&index=0&id=263bd3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263bd3cc",
  null
  
)

export default component.exports